import type { FaireProductEntity } from "../../entity_types/product";

export const p_c6kif398ii: FaireProductEntity = {
  token: "p_c6kif398ii",
  type: "product",
  name: "Helium 40 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/bea5d9199d85c357f541cf22e4dff87fae8e79459be21380a6cd6268c4fa00c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b7c9e2e952b686b90fdea4c09947f128f5ba612f0b4a551d64926988cde8115.png",
    "https://cdn.faire.com/fastly/1d3529a117e15e8cc27f2a99c887cbbf9a49be86cafd60bf45ea8164faf18bad.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:29.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
